import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { InfoDialogComponent } from '../../dialogs/info-dialog/info-dialog.component';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UiService } from '../../services/ui.service';
import { environment } from 'projects/bimbo/src/environments/environment';

@Component({
  selector: 'app-bimbo-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, OnDestroy {

  version = environment.version;;
  authEmployee: Subscription = null;
  model: any = { email: '', secret: ''};
  constructor(private authService: AuthenticationService, public dialog: MatDialog, private router: Router, public snackBar: MatSnackBar, private ui: UiService) { }

  ngOnInit() {

    this.authEmployee = this.authService.authUserSubject.subscribe(anEmployee => {

      if (anEmployee) {

        this.ui.stopSpinner();
        this.snackBar.open('Bienvenido.', null, {
          duration: 3000,
          panelClass: ['green-snackbar']
        });

        const path = this.authService.appLevel.sideBarItems[0].path;

        if (this.authService.href) {
          const url = this.authService.href;
          this.authService.href = null;
          this.router.navigate([url]);
        } else {
          this.router.navigate([path]);
        }

      }

    });

  }

  onEnter() {

    if (!this.model.email) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Debe de ingresar el número de Colaborador o un correo válido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.model.secret) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Debe de ingresar la contraseña.',
          close: 'Aceptar'
        }
      });

      return;

    }

    this.ui.showSpinner();
    this.authService.signIn(this.model).then(result => {

      this.ui.stopSpinner();
      if (!result) {
        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'El usuario o contraseña no son validos.',
            close: 'Aceptar'
          }
        });
      }

    }).catch(error => {
      this.ui.stopSpinner();
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: error,
          close: 'Aceptar'
        }
      });
    });

  }

  ngOnDestroy(): void {

    if (this.authEmployee && !this.authEmployee.closed) {
      this.authEmployee.unsubscribe();
      this.authEmployee = null;
    }

  }

}
